import { collectionGroup, FirestoreDataConverter, getDocs, limit, orderBy, query } from 'firebase/firestore'
import FirebaseService from '@/services/FirebaseService'
import { Material } from './material'

export const PO_PURCHASE_TYPE = {
  INVOICE: 'invoice',
  EXPENSE: 'expense',
  REIMBURSEMENT: 'reimbursement'
}

export const PURCHASE_ORDER_STATUS = {
  OPEN: 'open',
  PENDING_APPROVAL: 'pending_approval',
  CLOSED: 'close'
}

const getLastPurchaseOrderId = async () => {
  const db = await FirebaseService.firestore()
  const collectionRef = collectionGroup(db, 'purchaseOrders')
  const queryRef = query(collectionRef, orderBy('purchaseOrderId', 'desc'), limit(1))
  const querySnapshot = await getDocs(queryRef)

  if (querySnapshot.empty) return '1000'

  const purchaseOrder = Object.assign({}, querySnapshot.docs[0].data())
  return purchaseOrder.purchaseOrderId ? purchaseOrder.purchaseOrderId.substring(4) : '1000'
}
export class PurchaseOrderItem extends Material {
  lineItems: string[]

  constructor () {
    super()

    this.lineItems = []
  }
}

export class PurchaseOrder {
  id: string
  purchaseOrderId: string
  vendorId: string
  budgetId: string
  projectId: string
  status: string
  lineItems: string[]
  items: PurchaseOrderItem[]
  total: number
  shippingAddress: string
  attachments: []
  date: Date
  purchaseType: string
  submittedBy: string // userId
  approvedBy: string // userId
  createdAt: Date
  updatedAt: Date

  constructor () {
    this.purchaseOrderId = ''
    this.vendorId = ''
    this.budgetId = ''
    this.projectId = ''
    this.status = PURCHASE_ORDER_STATUS.OPEN
    this.lineItems = []
    this.items = []
    this.total = 0
    this.shippingAddress = ''
    this.attachments = []
    this.date = new Date()
    this.purchaseType = PO_PURCHASE_TYPE.INVOICE
    this.submittedBy = ''
    this.createdAt = new Date()
    this.updatedAt = new Date()
  }
}

export const generatePurchaseOrderId = async () => {
  const lastPurchaseOrderId = await getLastPurchaseOrderId()
  const label = 'PO'
  const year = new Date().getFullYear().toString().substring(2)
  const counter = parseInt(lastPurchaseOrderId)
  return `${label}${year}${counter + 1}`
}

export const purchaseOrderConverter: FirestoreDataConverter<PurchaseOrder, Document> = {
  toFirestore: (purchaseOrder: PurchaseOrder) => {
    const pOrder = JSON.parse(JSON.stringify(purchaseOrder)) as PurchaseOrder
    pOrder.total = typeof pOrder.total === 'string' ? parseFloat(pOrder.total) : pOrder.total
    pOrder.items.forEach((item) => {
      item.cost = typeof item.cost === 'string' ? parseFloat(item.cost) : item.cost
      item.quantity = typeof item.quantity === 'string' ? parseFloat(item.quantity) : item.quantity
    })
    pOrder.createdAt = pOrder.createdAt ? new Date(pOrder.createdAt) : new Date()
    pOrder.updatedAt = new Date()
    return Object.assign({}, JSON.parse(JSON.stringify(pOrder)))
  },

  fromFirestore: (snapshot, options) => {
    const data = snapshot.data(options)
    data.date = (typeof data.date === 'object') ? data.date.toDate() : data.date
    data.createdAt = (typeof data.createdAt === 'object') ? data.createdAt.toDate() : data.createdAt
    data.updatedAt = (typeof data.updatedAt === 'object') ? data.updatedAt.toDate() : data.updatedAt
    return Object.assign(new PurchaseOrder(), JSON.parse(JSON.stringify(data))) as PurchaseOrder
  }
}
